import { render, staticRenderFns } from "./Nominate.vue?vue&type=template&id=f86f5218&scoped=true&"
import script from "./Nominate.vue?vue&type=script&lang=js&"
export * from "./Nominate.vue?vue&type=script&lang=js&"
import style0 from "./Nominate.vue?vue&type=style&index=0&id=f86f5218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86f5218",
  null
  
)

export default component.exports